<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="my-2 font-weight-bold text-capitalize">Class Name - <span class="contenttext">{{pdfDetails.class_name}}</span></h4>
                </div>
                <div class="card-body">
                    <div id="custom-pdf-loader" *ngIf="customPdfLoader" style="height: 100vh;">
                        <img src="assets/images/pre-loader/loader-01.svg" alt="">
                    </div>
                    <pdf-viewer [src]="pdfTemplate" [zoom]="1.0"
                                [original-size]="false"
                                [fit-to-page]="true"
                                (after-load-complete)="callBackFn()"
                                [show-all]="true"
                                style="display: block; height: 100vh;"
                    >
                    </pdf-viewer>
                </div>
            </div>
        </div>
    </div>

</div>

